// src/services/storageActions.ts

import { message } from "antd";
import { StorageItem } from "../types/storage.types";

export class StorageActions {
  static async forceSync(swController?: ServiceWorker): Promise<void> {
    if (!swController) {
      message.error("Service Worker no disponible");
      return;
    }

    try {
      message.loading("Forzando sincronización...", 0);
      swController.postMessage({ type: "SYNC_NOW" });
      message.destroy();
      message.info("Sincronización iniciada");
    } catch (error) {
      message.destroy();
      message.error("Error iniciando sincronización");
      console.error("Error forzando sincronización:", error);
    }
  }

  // Función auxiliar para limpiar URLs de objetos al desmontar componente
  static cleanupObjectURLs(items: StorageItem[]): void {
    items.forEach((item) => {
      if (item.url) {
        URL.revokeObjectURL(item.url);
      }
    });
  }
}
